import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import React, { memo, useCallback } from 'react';

import type { IWebHookTab } from 'v2/interfaces/webhook';

import { useWebHookScreen } from '../context';
import styles from './styles';

const TabsWebHook = memo(() => {
  const { tab, setTab, loading } = useWebHookScreen();
  const classes = styles();

  const handleChange = useCallback(
    (_: React.ChangeEvent<{}>, v: IWebHookTab) => {
      if (v !== tab) {
        setTab(v);
      }
    },
    [setTab, tab]
  );

  return (
    <Tabs className={classes.tabs} onChange={handleChange} value={tab} indicatorColor='primary' textColor='primary'>
      <Tab className={classes.tab} disabled={tab !== 'webhook' && loading} value='webhook' label='WebHook' />
      <Tab className={classes.tab} disabled={tab !== 'historic' && loading} value='historic' label='Histórico' />
    </Tabs>
  );
});

export default TabsWebHook;
